import { useQuery } from '@apollo/client';

import { useThirdPartyOrganization } from 'bundles/unified-common/contexts/ThirdPartyOrganizationContext';
import GetThirdPartyOrganizationConfigurationPublicQuery from 'bundles/unified-common/queries/GetThirdPartyOrganizationConfigurationPublicQuery.graphql';
import type {
  GetThirdPartyOrganizationConfigurationPublicQueryQuery,
  GetThirdPartyOrganizationConfigurationPublicQueryQueryVariables,
} from 'bundles/unified-common/queries/__generated__/GetThirdPartyOrganizationConfigurationPublicQuery';

export const useSsoLockedOutStatus = () => {
  const thirdPartyOrganization = useThirdPartyOrganization();

  const { data, error, loading } = useQuery<
    GetThirdPartyOrganizationConfigurationPublicQueryQuery,
    GetThirdPartyOrganizationConfigurationPublicQueryQueryVariables
  >(GetThirdPartyOrganizationConfigurationPublicQuery, {
    variables: {
      organizationId: thirdPartyOrganization?.id || '',
    },
    errorPolicy: 'all',
    context: { clientName: 'gatewayGql' },
    skip: !thirdPartyOrganization?.id,
  });

  return {
    isSsoLockedOut: error ? false : data?.ThirdPartyOrganizationConfiguration?.isSsoLockedOutEnabled,
    isLoading: loading,
  };
};
